import {
  Box,
  Button,
  Grid,
  TextField,
} from "@mui/material";

import { useState, useEffect } from "react";
import { useFetcher } from "react-router-dom";

const  DistributorCustomBidfloorForm = ({ customBidfloor, onCancel }) => {
  const fetcher = useFetcher()
  const [value, setValue] = useState(customBidfloor)

  const handleSubmit = (e) => {
    fetcher.submit(
      { custom_bidfloor: value },
      { method: "post", fetcherKey: "bidder-submit" }
    )
  }

  useEffect(() => {
    if (fetcher.state === "idle" && fetcher.data) {
      const updateFailed = "errors" in fetcher.data

      if (!updateFailed) {
        onCancel()
      }
    }
  }, [fetcher, onCancel])

  return (
    <Grid container item>
      <Grid item xs={12}>
        <Box>
        <TextField
          hiddenLabel
          onChange={(e) => setValue(e.target.value)}
          error={fetcher.data?.errors?.custom_bidfloor ?? false}
          helperText={fetcher.data?.errors?.custom_bidfloor ?? ""}
          name="value"
          size="small"
          value={value}
          sx={{ mr: 2 }}
        />
          <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>Save</Button>
          <Button variant="outlined" onClick={onCancel}>Cancel</Button>
        </Box>
      </Grid>
    </Grid>
  );
}

export default DistributorCustomBidfloorForm;
